import { MetaConversionConstants } from "./constants/meta-conversion";
export class MetaConversionApi {
    static prepareDataGuid() {
        var _a, _b, _c, _d;
        const gwemid = (_b = (_a = window === null || window === void 0 ? void 0 : window.site_details) === null || _a === void 0 ? void 0 : _a.gwemid) !== null && _b !== void 0 ? _b : "";
        const gwguid = (_d = (_c = window === null || window === void 0 ? void 0 : window.site_details) === null || _c === void 0 ? void 0 : _c.gwguid) !== null && _d !== void 0 ? _d : "";
        return { gwemid, gwguid };
    }
    static getFBPCookie() {
        const regex = /_fbp=([^;]+)/;
        const match = regex.exec(document.cookie);
        return match ? match[1] : null;
    }
    static preparePayload(eventName, customData) {
        const timestamp = Math.floor(Date.now() / 1000);
        const userAgent = navigator.userAgent;
        const { gwemid, gwguid } = this.prepareDataGuid();
        const fbpCookie = this.getFBPCookie();
        const payload = {
            event_name: eventName,
            event_time: timestamp,
            action_source: "website",
            user_data: {
                client_user_agent: userAgent,
                fbp: fbpCookie
            },
            custom_data: Object.assign(Object.assign({}, customData), { gwemid,
                gwguid }),
            event_id: `${gwguid}${timestamp}`
        };
        return payload;
    }
    static sendFBQEvent(customData, eventName = MetaConversionConstants.viewContent) {
        // const payload = MetaConversionApi.preparePayload(eventName, customData);
        //
        // MetaConversionApi.trackFBQ(payload);
        // window.metaConversionApi?.(payload);
    }
    static trackFBQ(payload) {
        const { event_name, custom_data } = payload;
        if (typeof fbq === "function")
            fbq("track", event_name, custom_data);
    }
}
